import React from 'react'

export const Arrow = () => {
    return (
        <svg width="61" height="16" viewBox="0 0 61 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M0.292889 7.29289C-0.0976349 7.68341 -0.0976349 8.31658 0.292889 8.7071L6.65685 15.0711C7.04737 15.4616 7.68054 15.4616 8.07106 15.0711C8.46159 14.6805 8.46159 14.0474 8.07106 13.6568L2.41421 7.99999L8.07106 2.34314C8.46159 1.95262 8.46159 1.31945 8.07106 0.928928C7.68054 0.538403 7.04738 0.538403 6.65685 0.928927L0.292889 7.29289ZM61 7L0.999996 6.99999L0.999996 8.99999L61 9L61 7Z" fill="#00253D" />
        </svg>
    )
}
